/**
 * ? @description : App Component
 */

// Dependencies
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";

// CSS
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

// Route Component
import AllRoutes from "./components/routes/AllRoutes";

// Snackbar Component
import SnackbarMessage from "./components/Reusable/SnackbarMessage";

toast.configure();

function App() {
  // Pusher Notification
  // var pusher = new Pusher("acce9cfa4773cffeeae3", {
  //   cluster: "ap2",
  // });
  // var channel = pusher.subscribe("insert_teacher_notification");
  // channel.bind("new-record", function (data) {
  //   // alert(JSON.stringify(data));
  //   if (JSON.stringify(data) != null) {
  //     toast.success("Hey 👋, New Teacher Added. Please refresh the page !");
  //   }
  // });

  // CALL IT ONCE IN YOUR APP
  if (window !== undefined) {
    injectStyle();
  }

  return (
    <div className="container-fluid p-0 overflow-hidden">
      <ToastContainer />
      <AllRoutes />
      <SnackbarMessage />
    </div>
  );
}

export default App;
